import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import CardMedia from '@mui/material/CardMedia';
import TnC from './tnc.jpg';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalTheme } from '../../theme';

const PrivacyPolicyPage = () => {
    return (
        <ThemeProvider theme={GlobalTheme}>
            <CssBaseline />
            <Container maxWidth={false} disableGutters>
                <Box sx={{
                    '&.muiCard-root': { borderRadius: 0 },
                }}>
                    <CardMedia
                        sx={{ height: 500 }}
                        image={TnC}
                        title=""
                    />
                </Box>
            </Container>
            <Container maxWidth="lg" sx={{ mb: 2 }}>
                <Box sx={{ padding: 2, mt: 3 }}>
                    <Typography variant="h4" gutterBottom>
                        Cancellation Policy
                    </Typography>
                    <Typography id="terms-description" variant="subtitle2" fontWeight={200} component="div">
                        <p><strong>Cancellation by Travelers</strong></p>
                        <p>Up to 30 Days Before Travel Date: Full refund of the booking amount, excluding any non-refundable fees (e.g., processing or service fees).</p>
                        <p>15-29 Days Before Travel Date: 50% refund of the booking amount.</p>
                        <p>Less Than 15 Days Before Travel Date: No refund will be provided.</p>
                        <p><strong>Cancellation by Aaryan Holidays Pvt. Ltd</strong></p>
                        <p>In the rare event that we need to cancel your booking due to unforeseen circumstances, a full refund will be issued. Additionally, we will make every effort to provide alternative arrangements of equal or greater value.</p>
                        <p><strong>Special Circumstances</strong></p>
                        <p>For certain bookings, such as promotional deals or last-minute offers, cancellations may not be permitted. Specific terms will be highlighted during the booking process.</p>
                        <p><strong>No-Show Policy</strong></p>
                        <p>If a traveler fails to appear at the designated time and location without prior notice, no refund will be issued.</p>
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
};

export default PrivacyPolicyPage;
